import * as swcHelpers from '@swc/helpers';
import { GET_RETURN } from '../../../operations/queries/get-return.js';
import { mapFailures } from '../../../utils/map-failures.js';

const getReturnForConfirmation = function() {
    var _ref = swcHelpers.asyncToGenerator(function*({ client , query  }) {
        try {
            var ref;
            const { data , error  } = yield client.query({
                query: GET_RETURN,
                variables: {
                    input: query.variables
                },
                context: {
                    forwardHeaders: {
                        'Accept-Language': query.locale
                    }
                },
                fetchPolicy: 'cache-first'
            });
            if (error) {
                console.error(error);
                throw new Error(error.message);
            }
            return {
                returnData: data.getReturn.return ? {
                    returnLabelUrl: data.getReturn.return.returnLabelUrl,
                    status: data.getReturn.return.status
                } : null,
                failures: ((ref = data.getReturn) === null || ref === void 0 ? void 0 : ref.failures) ? mapFailures(data.getReturn.failures) : null
            };
        } catch (e) {
            console.error(`Failed to query return status: ${e}`);
        }
        return {
            returnData: null,
            failures: [
                'technicalError'
            ]
        };
    });
    return function getReturnForConfirmation(_) {
        return _ref.apply(this, arguments);
    };
}();

export { getReturnForConfirmation };
//# sourceMappingURL=get-return-for-confirmation.js.map
